import { Button } from '@unified-checkout/design-system';

import type { IButtonsGroupProps } from '@app/dashboard/types/innerLayout/buttons-groups';
import { useScreenWidth } from '@app/dashboard/hooks/useScreenWidth';
import { SMALL_MOBILE_BREAKPOINT } from '@app/dashboard/constants/break-points';

import styles from './buttons-group.module.scss';

const ButtonsGroup = ({
  actions,
  activeBtn,
  onActiveBtnChange,
}: IButtonsGroupProps) => {
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= SMALL_MOBILE_BREAKPOINT;

  const handleActiveBtn = (actionId: string) => {
    onActiveBtnChange?.(actionId);
  };

  return (
    <div className={styles['buttons-group']}>
      {actions.map((actionProps, index) => (
        <div
          key={actionProps.id ?? index}
          className={styles['buttons-group__action']}
          data-btn-active={activeBtn === actionProps.id}
        >
          <Button
            {...actionProps}
            size={isMobile ? 'sm' : actionProps.size || 'md'}
            color={activeBtn === actionProps.id ? 'primary' : 'secondary'}
            variant="link"
            onClickHandler={() => {
              actionProps.onClickHandler?.();
              handleActiveBtn(actionProps.id);
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default ButtonsGroup;
